import { AnyAction } from 'redux';

import {
  CART_ADD_COUPON_FAILED,
  CART_ADD_COUPON_REQUESTED,
  CART_ADD_COUPON_SUCCEEDED,
  CART_ITEM_ADDED,
  CART_ITEM_ADDING,
  CART_ITEM_ADDING_FAILED,
  CART_ITEM_MODIFIED,
  CART_ITEM_MODIFYING,
  CART_ITEM_MODIFYING_FAILED,
  CART_ITEM_REMOVED,
  CART_ITEM_REMOVING,
  CART_ITEM_REMOVING_FAILED,
  CART_ITEM_SEAT_ADDED,
  CART_ITEM_SEAT_ADDING,
  CART_ITEM_SEAT_REMOVED,
  CART_ITEM_SEAT_REMOVING,
  CART_ITEM_SEAT_REMOVING_FAILED,
  CART_LOADED,
  CART_LOADING,
  CART_LOADING_FAILED,
  CART_PAYMENT_INFORMATION_UPDATED,
  CART_PAYMENT_INFORMATION_UPDATING,
  CART_PAYMENT_INFORMATION_UPDATING_FAILED,
  CART_SHIPPING_INFORMATION_UPDATED,
  CART_SHIPPING_INFORMATION_UPDATING,
  CART_SHIPPING_INFORMATION_UPDATING_FAILED,
  UPDATE_EXPIRATION,
  SHOW_FINISHER,
  HIDE_FINISHER,
  CART_ITEM_REPLIES_UPDATING,
  CART_ITEM_REPLIES_UPDATED,
  CART_ITEM_REPLIES_UPDATING_FAILED,
  CART_ITEM_SEAT_CHANGING_VARIANT,
  CART_ITEM_SEAT_CHANGE_VARIANT_FAILED,
  CART_ITEM_SEAT_CHANGED_VARIANT,
  CART_ITEM_SEAT_CHANGE_VARIANT_DONE,
  CART_NULLIFY,
} from '@ttstr/actions/cart';
import { Cart } from '@ttstr/api';

export class ReduxState {
  cart?: Cart;
  cartReceived: boolean;
  loading: boolean;
  expiresIn: number;
  showFinisher: boolean;
}

const initialState: ReduxState = {
  cart: null,
  cartReceived: false,
  loading: false,
  expiresIn: null,
  showFinisher: false,
};

const cart = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  const cart = action.payload?.cart as Cart;
  switch (action.type) {
    case CART_LOADING:
    case CART_ITEM_ADDING:
    case CART_ITEM_MODIFYING:
    case CART_ITEM_REMOVING:
    case CART_ITEM_SEAT_ADDING:
    case CART_ITEM_SEAT_REMOVING:
    case CART_ITEM_SEAT_CHANGING_VARIANT:
    case CART_ADD_COUPON_REQUESTED:
    case CART_SHIPPING_INFORMATION_UPDATING:
    case CART_PAYMENT_INFORMATION_UPDATING:
    case CART_ITEM_REPLIES_UPDATING:
      return {
        ...state,
        loading: true,
      };
    case CART_LOADING_FAILED:
    case CART_ITEM_ADDING_FAILED:
    case CART_ITEM_MODIFYING_FAILED:
    case CART_ITEM_REMOVING_FAILED:
    case CART_ITEM_SEAT_REMOVING_FAILED:
    case CART_ITEM_SEAT_CHANGE_VARIANT_FAILED:
    case CART_ADD_COUPON_FAILED:
    case CART_PAYMENT_INFORMATION_UPDATING_FAILED:
    case CART_SHIPPING_INFORMATION_UPDATING_FAILED:
    case CART_ITEM_REPLIES_UPDATING_FAILED:
      return {
        ...state,
        ...( cart && {
          cart,
          expiresIn: getExpiration(cart),
          showFinisher: state.showFinisher && Boolean(cart?.id) && Boolean(cart?.items.length),
        }),
        loading: false,
        cartReceived: true,
      };
    case CART_LOADED:
    case CART_ITEM_ADDED:
    case CART_ITEM_MODIFIED:
    case CART_ITEM_SEAT_CHANGED_VARIANT:
    case CART_ITEM_SEAT_CHANGE_VARIANT_DONE:
    case CART_ITEM_REMOVED:
    case CART_ITEM_SEAT_ADDED:
    case CART_ITEM_SEAT_REMOVED:
    case CART_ADD_COUPON_SUCCEEDED:
    case CART_PAYMENT_INFORMATION_UPDATED:
    case CART_SHIPPING_INFORMATION_UPDATED:
    case CART_ITEM_REPLIES_UPDATED:
      return {
        ...state,
        cart,
        loading: false,
        cartReceived: true,
        expiresIn: getExpiration(cart),
        showFinisher: state.showFinisher && Boolean(cart?.id) && Boolean(cart?.items.length),
      };
    case UPDATE_EXPIRATION:
      return {
        ...state,
        expiresIn: getExpiration(state.cart),
      };
    case SHOW_FINISHER:
      return {
        ...state,
        showFinisher: true,
      };
    case HIDE_FINISHER:
      return {
        ...state,
        showFinisher: false,
      };
    case CART_NULLIFY:
      return {
        ...state,
        cart,
      };
    default:
      return state;
  }
};

export default cart;

function getExpiration(cart: Cart) {
  return cart?.expires_at ? Math.floor((cart.expires_at.getTime() - Date.now()) / 1000) : null;
}
